import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../../env";

const AddRoomModal = ({ show, onClose, onSubmit }) => {
  const [roomType, setRoomType] = useState("");
  const [description, setDescription] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/room-config/add-room`,
        {
          roomType,
          description,
          createdBy: 1,
        }
      );

      console.log(response, "Response");
      alert("Room added successfully!");
      setRoomType("");
      setDescription("");
    } catch (error) {
      alert("Error adding room");
      console.error("Error adding room:", error);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: "rgba(156, 153, 153, 0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add New Room</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label className="form-label text-muted">Room Type</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Add Room Type"
                  name="type"
                  value={roomType}
                  onChange={(e) => setRoomType(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mt-3">
                <label className="form-label text-muted">Description</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Description"
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="modal-footer mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
              <button type="submit" className="btn btn-secondary">
                Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRoomModal;
